import { useCallback, useState } from 'react';

export type DrawerType =
  | 'projectInfo'
  | 'activities'
  | 'tasks'
  | 'appointments'
  | 'comments'
  | 'messages'
  | 'mail'
  // Composing is its own surface: the + on the card writes a message, it does
  // not browse threads, so it opens the composer alone rather than stacking it
  // on top of the 1200px thread drawer.
  | 'mailCompose'
  | 'files'
  | 'caratPlannings'
  | null;

export interface DrawerPayload {
  [key: string]: any;
}

export interface DrawerState {
  type: DrawerType;
  payload?: DrawerPayload;
}

/**
 * Hook to manage drawer state - ensures only one drawer is open at a time
 */
export const useDrawerController = () => {
  const [drawerState, setDrawerState] = useState<DrawerState>({
    type: null,
    payload: undefined,
  });

  const openDrawer = useCallback((type: DrawerType, payload?: DrawerPayload) => {
    setDrawerState({ type, payload });
  }, []);

  const closeDrawer = useCallback(() => {
    setDrawerState({ type: null, payload: undefined });
  }, []);

  const isDrawerOpen = useCallback((type: DrawerType) => {
    return drawerState.type === type;
  }, [drawerState.type]);

  return {
    activeDrawerType: drawerState.type,
    activeDrawerPayload: drawerState.payload,
    openDrawer,
    closeDrawer,
    isDrawerOpen,
  };
};
